import {
  Component,
  ElementRef,
  Inject,
  NgZone,
  OnDestroy,
  OnInit,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { PickupLocationsDialogComponent } from '../pickup-locations-dialog/pickup-locations-dialog.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
// import { MapsAPILoader } from '';
import { Loader } from '@googlemaps/js-api-loader';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { MapApiKey, OrderLocations } from 'src/app/utils/systemEnums';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DataService } from 'src/@order/services/data.service';
import { LocationPointType } from 'src/@order/commonData/location-point-type';
import {
  PACKAGESIZETYPE,
  countries,
  locations,
  standardPackageSizes,
} from 'src/@order/commonData/commonUiData';
import { InfoDialogComponent } from '../info-dialog/info-dialog.component';
import { AuthServiceLocal } from 'src/@order/services/auth.service';
import { WhatToSendDialogComponent } from '../what-to-send-dialog/what-to-send-dialog.component';
import { appMessages } from 'src/@order/commonData/app-messages';

import { GoogleMap, MapMarker } from '@angular/google-maps';
import { InfoDialog2Component } from '../info-dialog2/info-dialog2.component';

interface mode {
  add: boolean;
  update: boolean;
}

@Component({
  selector: 'app-add-new-location-dialog',
  templateUrl: './add-new-location-dialog.component.html',
  styleUrls: ['./add-new-location-dialog.component.scss'],
})
export class AddNewLocationDialogComponent implements OnInit, OnDestroy {
  heading: string = '';
  cityID = '';
  appMessages = appMessages;
  form!: FormGroup;
  // latitude!: any;
  // longitude!: any;
  // zoom: number = 8;
  address!: string;
  mapLoadingTimes = 0;
  countries = countries;
  // private geoCoder;
  selectedCountryCode: string;
  mode: mode = {
    add: false,
    update: false,
  };
  // formatedAddress;

  @ViewChild('search', { static: true })
  public searchElementRef!: ElementRef;
  // Restrict the map to Ghana and Nigeria
  // LEFT,  BOTTOM, RIGHT, TOP(north)
  countryRestriction = {
    latLngBounds: {},
    strictBounds: false,
  };
  // standardPackageSizes : PACKAGESIZETYPE[] = [...standardPackageSizes];

  latitude: number = 12.34;
  longitude: number = 56.78;
  zoom: number = 12;
  formatedAddress: string;
  geoCoder: google.maps.Geocoder;
  isAddressSelectedFromAutocomplete: boolean = false;
  isValidGpsLocation: boolean = false;

  mapOptions: google.maps.MapOptions = {
    restriction: {
      latLngBounds: {
        north: 15,
        south: 4,
        east: 20,
        west: -10,
      },
      strictBounds: true,
    },
  };

  markerOptions: google.maps.MarkerOptions = {
    draggable: true,
  };

  ghanaBounds = {
    east: 1.0601216976, // right
    north: 11.0994559693, // TOP
    south: 4.71046214438, // bottom
    west: -3.24437008301, // left
  };

  nigeriaBounds = {
    east: 14.5771777686, // right
    north: 13.8659239771, // TOP
    south: 4.24059418377, // bottom
    west: 2.69170169436, // left
  };

  selectedCountry;
  customerData;
  maxLength: string = '10'; // Default value;

  constructor(
    @Inject(MAT_DIALOG_DATA) public _data: any,
    public _matDialogRef: MatDialogRef<AddNewLocationDialogComponent>,
    private _matDialog: MatDialog,
    // private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private _auth: AuthServiceLocal,
    private _dataService: DataService,
    private _matsnackbar: MatSnackBar,
    private afs: AngularFirestore,
    private _fb: FormBuilder
  ) {
    console.log('_data', this._data);
    this.customerData = JSON.parse(localStorage.getItem('authUser'));

    this.setCountryRestriction();
    this.heading = this._data.heading;

    this.countries.map((country) => {
      if (country.title == this.selectedCountry) {
        country.selected = 1;
        this.selectedCountryCode = country.code;
      } else {
        country.selected = 0;
      }
    });

    // console.log("this.selectedCountryCode", this.selectedCountryCode);
    // console.log("this.countries", this.countries);

    if (this._data?.location) {
      this.mode.update = true;
      this.mode.add = false;
      this.createForm(this._data?.location);
      const initialNumber = this.form.get('personNumber')?.value;
      this.updatePhoneNumberValidation(initialNumber);
      this.form.markAllAsTouched();
      this.latitude = this._data?.location.latitude;
      this.longitude = this._data?.location.longitude;
      // Preserve existing placeId when editing without changing address
      this.cityID =
        this._data?.location?.placeId ||
        this._data?.location?.placeID ||
        this._data?.location?.place_id ||
        this.cityID;
      this.getAddress(
        this._data?.location.latitude,
        this._data?.location.longitude
      );
      // this.getAddress(this._data?.location.latitude, this._data?.location.longitude)

      /* auto scrollup */
      // if(this._data.isHeavyItemAndRelocateOrder && !this.form.get('packageSize')?.value){
      //   setTimeout(() => {
      //     document.getElementById("packageSizeWrapper")?.scrollIntoView({
      //         behavior: "smooth",
      //         block: "start",
      //         inline: "nearest"
      //     });
      //   }, 1000);
      // }
    } else {
      this.mode.add = true;
      this.mode.update = false;
      this.createForm();
      this.setCurrentLocation();
    }
  }

  setCountryRestriction() {
    this.selectedCountry = localStorage.getItem('country');

    switch (this.selectedCountry) {
      case 'Ghana':
        this.countryRestriction['latLngBounds'] = this.ghanaBounds;
        this.countryRestriction['strictBounds'] = true;
        break;

      case 'Nigeria':
        this.countryRestriction['latLngBounds'] = this.nigeriaBounds;
        this.countryRestriction['strictBounds'] = true;
        break;
    }
  }

  ngOnInit() {
    this.loadPlaceAutoComplete();

    this.form.get('personNumber').valueChanges.subscribe((res) => {
      // Add debounce to prevent excessive calls
      this.updatePhoneNumberValidation(res);
    });
  }

  private updatePhoneNumberValidation(value: string): void {
    // Skip if value is null/undefined to prevent unnecessary updates
    if (value === null || value === undefined) return;

    // Get current validators without required (we'll add it back)
    const currentValidators = this.form.get('personNumber').validator;
    const newValidators = [Validators.required]; // Always include required

    const valueStr = String(value || '');
    const pattern =
      valueStr[0] === '0'
        ? this.selectedCountryCode === '+233'
          ? '^(?!0{5,})[0-9]{10}$'
          : '^(?!0{5,})[0-9]{11}$'
        : this.selectedCountryCode === '+233'
        ? '^(?!0{5,})[0-9]{9}$'
        : '^(?!0{5,})[0-9]{10}$';

    newValidators.push(Validators.pattern(pattern));

    // Only update if validators actually changed
    if (JSON.stringify(currentValidators) !== JSON.stringify(newValidators)) {
      this.form.get('personNumber').setValidators(newValidators);
      this.form
        .get('personNumber')
        .updateValueAndValidity({ emitEvent: false }); // Prevent loop
    }

    this.maxLength =
      valueStr[0] === '0'
        ? this.selectedCountryCode === '+233'
          ? '10'
          : '11'
        : this.selectedCountryCode === '+233'
        ? '9'
        : '10';
  }

  checkZeroNumber(value: string): boolean {
    return value?.[0] === '0';
  }

  onPaste(event: ClipboardEvent): void {
    const pastedText = event.clipboardData?.getData('text') || '';
    console.log('Pasted text:', pastedText);

    // Example logic to update maxlength
    if (this.checkZeroNumber(pastedText)) {
      this.maxLength = this.selectedCountryCode === '+233' ? '10' : '11';
    } else {
      this.maxLength = this.selectedCountryCode === '+233' ? '9' : '10';
    }
  }

  createForm(data = null) {
    console.log('data?.mobile', data?.mobile);

    if (this._data.isPickup) {
      this.form = this._fb.group({
        contactPerson: [
          data?.name || '',
          [Validators.required, Validators.pattern('^[A-Za-z][A-Za-z0-9 ]*$')],
        ],
        personNumber: [
          data?.mobile || '',
          [
            Validators.required,
            Validators.pattern(
              this.selectedCountryCode == '+233' ? '[0-9]{9,9}' : '[0-9]{10,10}'
            ),
          ],
        ],
        pickupAddress: [
          data?.address || '',
          [Validators.required, this.validAddressValidator.bind(this)],
        ],
        landMark: [data?.landmark || ''],
        locality: [data?.locality || ''],
      });
    } else {
      this.form = this._fb.group({
        contactPerson: [
          data?.name || '',
          [Validators.required, Validators.pattern('^[A-Za-z][A-Za-z0-9 ]*$')],
        ],
        personNumber: [
          data?.mobile || '',
          [
            Validators.required,
            Validators.pattern(
              this.selectedCountryCode == '+233' ? '[0-9]{9,9}' : '[0-9]{10,10}'
            ),
          ],
        ],
        pickupAddress: [
          data?.address || '',
          [Validators.required, this.validAddressValidator.bind(this)],
        ],
        landMark: [data?.landmark || ''],
        cashCollectionAmount: [
          data?.collectCash || '',
          Validators.pattern(/^[1-9][0-9]*$/),
        ],
        // standardPackageSizes : [this._data.isHeavyItemAndRelocateOrder ? JSON.parse(JSON.stringify(standardPackageSizes)) : []],
        // packageSize : [''],
        locality: [data?.locality || ''],
      });

      if (
        !this._data.isPickup &&
        (this._data.isStandardOrder || this._data.isHeavyItemAndRelocateOrder)
      ) {
        this.form.addControl(
          'isPhlenuTrustCheckApplied',
          this._fb.control(data?.isPhlenuTrustCheckApplied || false)
        );
      }

      // if(this._data?.isHeavyItemAndRelocateOrder){
      //   this.form.get('packageSize').setValidators(Validators.required);
      // }else{
      //   this.form.get('packageSize').setValidators(null);
      // }

      // if(data?.packageSize && this.form.get('standardPackageSizes')?.value && this._data.isHeavyItemAndRelocateOrder){
      //   this.form.get('standardPackageSizes').value.map((item) => {
      //     if(item.id == data.packageSize){
      //       item.isSelected = 1;
      //       this.form.get('packageSize').setValue(item);
      //     }else{
      //       item.isSelected = 0;
      //     }
      //   })
      // }
    }

    this.checkZeroNumber(data?.mobile);
    this.formatedAddress = data?.address || '';

    // If we have existing data, mark as valid since it was previously validated
    if (data?.address && data?.latitude && data?.longitude) {
      this.isAddressSelectedFromAutocomplete = true;
      this.isValidGpsLocation = true;
    }
    // Initialize phone validators based on current value (handles edit mode without typing)
    this.updatePhoneNumberValidation(
      this.form.get('personNumber')?.value || ''
    );
  }

  changeCountry() {
    this.form
      .get('personNumber')
      .setValidators(
        Validators.pattern(
          this.selectedCountryCode == '+233' ? '[0-9]{9,9}' : '[0-9]{10,10}'
        )
      );
    this.form.get('personNumber').updateValueAndValidity();
  }

  onBack() {
    // console.log("this._data.isPickup", this._data.isPickup);
    this._matDialogRef.close();
    this._matDialog.open(PickupLocationsDialogComponent, {
      panelClass: ['commonDialogWrapper'],
      backdropClass: 'dialogBackdrop',
      autoFocus: false,
      disableClose: false,
      width: '610px',
      data: {
        heading: 'Select Your Pickup Address',
        isPickup: this._data.isPickup,
        locations: locations,
        selected: this._data?.selected || null,
        isHeavyItemAndRelocateOrder: this._data.isHeavyItemAndRelocateOrder,
      },
    });
  }

  onclose() {
    if (!this._data.isPickup) {
      this._dataService.dropoffCloseWithoutData.emit(true);
      this._matDialogRef.close();
    } else {
      this._matDialogRef.close();
    }
  }

  openWhatToSendDialog() {
    this._matDialog.open(WhatToSendDialogComponent, {
      panelClass: ['commonDialogWrapper'],
      autoFocus: false,
      disableClose: false,
      width: '610px',
    });
  }

  locationChange() {
    this.latitude = null;
    this.longitude = null;
    this.isAddressSelectedFromAutocomplete = false;
    this.isValidGpsLocation = false;
    this.formatedAddress = null;
    this.form.get('locality')?.setValue('');
    // Trigger validation update
    this.form.get('pickupAddress')?.updateValueAndValidity();
  }

  onAddressInput(event: any) {
    // Reset validation flags when user types manually
    if (!this.isAddressSelectedFromAutocomplete) {
      this.isAddressSelectedFromAutocomplete = false;
      this.isValidGpsLocation = false;
      this.formatedAddress = null;
      this.form.get('locality')?.setValue('');
      // Trigger validation update
      this.form.get('pickupAddress')?.updateValueAndValidity();
    }
  }

  // Get Current Location Coordinates
  private setCurrentLocation() {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;
        this.zoom = 8;
        this.getAddress(this.latitude, this.longitude);
      });
    }
  }

  getAddress(latitude, longitude) {
    if (this.geoCoder)
      this.geoCoder?.geocode(
        { location: { lat: latitude, lng: longitude } },
        (results, status) => {
          // console.log("results", results);
          if (status === 'OK') {
            if (results[0]) {
              if (!this.zoom) this.zoom = 12;
              this.address = results[0].formatted_address;
              this.handleAddressChange(results[0]);
              this.mapLoadingTimes++;
            } else {
              window.alert('No results found');
            }
          } else {
            window.alert('Geocoder failed due to: ' + status);
          }
        }
      );
  }

  markerDragEnd(event: google.maps.MapMouseEvent) {
    if (event.latLng) {
      this.latitude = event.latLng.lat();
      this.longitude = event.latLng.lng();
      this.isAddressSelectedFromAutocomplete = true; // Marker drag is considered a valid selection
      this.validateGpsCoordinates();
      this.getAddress(this.latitude, this.longitude);
    }
  }

  public handleAddressChange(address) {
    console.log('address', address);

    const addCompLength = address.address_components.length;
    console.log('address.address_components', address.address_components);

    const addressParts = {
      landMark: address.address_components.filter((item) => {
        if (item.types[2] == 'sublocality_level_1') return item.long_name;
      })[0],

      city: address.address_components.filter((item) => {
        if (item.types[0] == 'administrative_area_level_2')
          return item.long_name;
      })[0],

      state: address.address_components.filter((item) => {
        if (item.types[0] == 'administrative_area_level_1')
          return item.long_name;
      })[0],

      country: address.address_components.filter((item) => {
        if (item.types[0] == 'country') return item.long_name;
      })[0],

      zipcode: address.address_components.filter((item) => {
        if (item.types[0] == 'postal_code') return item.long_name;
      })[0],

      locality: address.address_components.filter((item) => {
        if (item.types[0] == 'locality') return item.long_name;
      })[0],
    };
    this.cityID = address?.place_id;

    console.log('addressParts', addressParts, this.cityID, address?.place_id);

    if (addressParts['country']?.long_name && addCompLength)
      if (addressParts['country'].long_name != this.selectedCountry) {
        this.countryUnmatched();
      } else {
        this.formatedAddress = address?.formatted_address;
        this.form.get('pickupAddress').setValue(address?.formatted_address);
        this.isValidGpsLocation = true;
        // Trigger validation update
        this.form.get('pickupAddress')?.updateValueAndValidity();
      }
    if (addressParts?.landMark && this._data.isPickup) {
      this.form.get('landMark').setValue(addressParts.landMark.long_name);
    }
    // Always set or clear locality to avoid stale values (e.g., prior entries like "Jodhpur")
    const resolvedLocality =
      addressParts['locality']?.long_name ||
      addressParts['city']?.long_name ||
      addressParts['landMark']?.long_name ||
      '';
    this.form.get('locality')?.setValue(resolvedLocality);
  }

  countryUnmatched() {
    if (this.form.get('pickupAddress').value) {
      this.form.get('landMark').setValue('');
      this.form.get('landMark').reset();
      this.form.get('pickupAddress').setValue('');
      this.form.get('pickupAddress').reset();
      this.form.updateValueAndValidity();
      this.formatedAddress = null;
      this.isAddressSelectedFromAutocomplete = false;
      this.isValidGpsLocation = false;
      this.latitude = null;
      this.longitude = null;
      this._matsnackbar.open(
        `Your selected location is not in ${this.selectedCountry}. Please pick a place within ${this.selectedCountry}.`,
        'Okay',
        { duration: 10000 }
      );
    }
  }

  loadPlaceAutoComplete() {
    // Check if Google Maps is already loaded
    if (typeof google !== 'undefined' && google.maps) {
      this.initializeGoogleMaps();
      return;
    }

    // Only load if not already present
    const loader = new Loader({
      apiKey: MapApiKey,
      libraries: ['places'],
    });

    loader
      .load()
      .then(() => {
        this.initializeGoogleMaps();
      })
      .catch((error) => {
        console.error('Failed to load Google Maps:', error);
      });
  }

  private initializeGoogleMaps() {
    this.geoCoder = new google.maps.Geocoder();

    const autocomplete = new google.maps.places.Autocomplete(
      this.searchElementRef?.nativeElement,
      {
        componentRestrictions: {
          country: localStorage.getItem('country') === 'Ghana' ? 'GH' : 'NG',
        },
      }
    );

    autocomplete.addListener('place_changed', () => {
      this.ngZone.run(() => {
        const place: google.maps.places.PlaceResult = autocomplete.getPlace();

        if (!place.geometry || !place.geometry.location) {
          this.isAddressSelectedFromAutocomplete = false;
          this.isValidGpsLocation = false;
          this.form.get('pickupAddress')?.updateValueAndValidity();
          return;
        }

        this.latitude = place.geometry.location.lat();
        this.longitude = place.geometry.location.lng();
        this.zoom = 12;
        this.isAddressSelectedFromAutocomplete = true;
        this.validateGpsCoordinates();
        this.getAddress(this.latitude, this.longitude);
      });
    });
  }

  onSubmit() {
    if (!this.isValidGpsLocation || !this.isAddressSelectedFromAutocomplete) {
      this._matsnackbar.open(
        `Please select a valid address from the dropdown suggestions to ensure accurate location detection.`,
        'OKAY',
        { duration: 8000 }
      );
      return;
    }

    if (!this.latitude || !this.longitude || !this.isValidGpsLocation) {
      this._matsnackbar.open(
        `The location you entered cannot be located on the GPS. Please enter & choose a location closest to your desired address. Thanks`,
        'OKAY',
        { duration: 8000 }
      );
    } else {
      if (this.mode.add) {
        const timestamp = new Date();
        const userId = this.customerData.id;
        const locationPoint: LocationPointType = this.createAddLocationObj(
          null,
          userId,
          timestamp
        );
        console.log('locationPoint', locationPoint);

        let fullLocationDrop;
        if (!this._data.isPickup) {
          // if(this._data.isHeavyItemAndRelocateOrder){
          //   fullLocationDrop = {...locationPoint, collectCash : this.form.get('cashCollectionAmount').value ? String(this.form.get('cashCollectionAmount').value) : ''}
          // }else{
          fullLocationDrop = {
            ...locationPoint,
            collectCash: this.form.get('cashCollectionAmount').value
              ? String(this.form.get('cashCollectionAmount').value)
              : '',
          };
          // }
        } else {
          fullLocationDrop = { ...locationPoint };
        }

        this.afs
          .collection(String(OrderLocations))
          .doc(`${userId}_${timestamp.getTime()}`)
          .set(fullLocationDrop)
          .then((res) => {
            // this.onBack();
            if (this._data.isPickup) {
              this._dataService.emitData(fullLocationDrop);
              this._matDialogRef.close(fullLocationDrop);
              this._matsnackbar.open('Pickup Selected Successfully', 'OKAY', {
                duration: 3000,
              });
              console.log('bruhh1');
            } else {
              this._dataService.emitDropoffData(fullLocationDrop);
              this._matDialogRef.close(fullLocationDrop);
              this._matsnackbar.open('Dropoff Selected Successfully', 'OKAY', {
                duration: 3000,
              });
            }

            // this._matsnackbar.open('Location Point added Successfully', 'OKAY', {duration : 3000})
          })
          .catch((err) => {
            this._matsnackbar.open(
              'failed to add location point please try again',
              'OKAY',
              { duration: 3000 }
            );
            this.form.reset();
          });
      } else if (this.mode.update) {
        const timestamp = new Date();
        const locationPoint: LocationPointType = this.createAddLocationObj(
          this._data.location,
          this._data.location.userID,
          timestamp
        );

        let fullLocationDrop;
        if (!this._data.isPickup) {
          // if(this._data.isHeavyItemAndRelocateOrder){
          //   fullLocationDrop = {...locationPoint, collectCash : this.form.get('cashCollectionAmount').value ? String(this.form.get('cashCollectionAmount').value) : '', packageSize : this.form.get('packageSize').value ? this.form.get('packageSize').value?.id : ''}
          // }else{
          fullLocationDrop = {
            ...locationPoint,
            collectCash: this.form.get('cashCollectionAmount')?.value
              ? String(this.form.get('cashCollectionAmount').value)
              : '',
            packageSize: '',
          };
          // }
        } else {
          fullLocationDrop = { ...locationPoint };
        }

        // update the doc here ../
        this.afs
          .collection(String(OrderLocations))
          .doc(this._data.location.id)
          .update(fullLocationDrop)
          .then((res) => {
            // this.onBack();
            if (this._data.isPickup) {
              this._dataService.emitData(fullLocationDrop);
              this._matDialogRef.close(fullLocationDrop);
              this._matsnackbar.open('Pickup Selected Successfully', 'OKAY', {
                duration: 3000,
              });
              console.log('bruhh2');
            } else {
              this._dataService.emitDropoffData(fullLocationDrop);
              this._matDialogRef.close(fullLocationDrop);
              this._matsnackbar.open('Dropoff Selected Successfully', 'OKAY', {
                duration: 3000,
              });
            }
          })
          .catch((err) => {
            this._matsnackbar.open(
              'Failed to select location point please try again',
              'OKAY',
              { duration: 3000 }
            );
            this.form.reset();
          });
      }
    }
  }

  createAddLocationObj(data = null, userId, timestamp) {
    // Force isPhlenuTrustCheckApplied to 0 if conditions are met
    let trustCheckValue =
      this.form.get('isPhlenuTrustCheckApplied')?.value || false;
    if (!this._data.isPickup && this._data.isShowTrustCheck == 0) {
      trustCheckValue = 0;
    }
    console.log(
      'trustCheckValue',
      trustCheckValue,
      !this._data.isPickup,
      this._data.isShowTrustCheck,
      this.form
    );
    const resolvedPlaceId = this.cityID || data?.placeId || '';
    console.log(
      '[AddNewLocationDialog] createAddLocationObj:placeId',
      resolvedPlaceId
    );
    return {
      address: String(this.form.value?.pickupAddress) || '',
      countryCode: String(this.selectedCountryCode),
      dialCode: String(this.selectedCountryCode),
      fullAddress: '',
      id: data?.id || `${userId}_${timestamp.getTime()}`,
      isPickup: Number(this._data.isPickup ? 1 : 0),
      landmark: String(this.form.value?.landMark) || '',
      latitude: Number(this.latitude),
      locationId: data?.locationId || `${userId}_${timestamp.getTime()}`,
      longitude: Number(this.longitude),
      mobile: String(this.form.value?.personNumber),
      name: String(this.form.value?.contactPerson),
      phone: String(this.form.value?.personNumber),
      time: String(timestamp),
      timestamp: Number(timestamp.getTime()),
      locality: this.form.get('locality').value || '',
      updateAt: Number(timestamp.getTime()),
      userID: data?.userID || Number(userId),
      isPhlenuTrustCheckApplied: trustCheckValue,
      placeId: resolvedPlaceId,
    };
  }

  openInfoDialog() {
    if (!this._auth.orderInfo) {
      this.getInfoData();
    } else {
      const dialog = this._matDialog.open(InfoDialog2Component, {
        panelClass: ['commonDialogWrapper'],
        backdropClass: 'dialogBackdrop',
        autoFocus: false,
        width: '510px',
        data: {
          heading: 'Info',
          message: this._auth.orderInfo,
          type: 'cashCollection',
          icon: true,
        },
      });
    }
  }

  getInfoData() {
    this._auth
      .getOrderInfo({ country: localStorage.getItem('country') })
      .subscribe((res: any) => {
        if (res?.response == 1) {
          this._auth.orderInfo = res.data;
          this.openInfoDialog();
        } else {
          this._matsnackbar.open(res.message, 'OKAY', { duration: 4000 });
          this._auth.orderInfo = '';
        }
      });
  }

  onSelectPackage(i) {
    // this.standardPackageSizes[i].isSelected == 1 ? this.standardPackageSizes[i].isSelected = 0 : this.standardPackageSizes[i].isSelected = 1;
    // this.form.get('standardPackageSizes').value.map((item, index) => {
    //   if(i == index){
    //     item.isSelected = 1;
    //     this.form.get('packageSize').setValue(item);
    //     this.form.get('packageSize').updateValueAndValidity();
    //   }else{
    //     item.isSelected = 0;
    //   }
    // })
  }

  // Custom validator for address selection
  validAddressValidator(control: any) {
    if (!control.value) {
      return { required: true };
    }

    if (!this.isAddressSelectedFromAutocomplete) {
      return { addressNotSelected: true };
    }

    if (!this.isValidGpsLocation) {
      return { invalidGpsLocation: true };
    }

    return null;
  }

  // Validate GPS coordinates are within expected bounds
  validateGpsCoordinates(): void {
    if (!this.latitude || !this.longitude) {
      this.isValidGpsLocation = false;
      return;
    }

    const isValidRange = (lat: number, lng: number): boolean => {
      // Check if coordinates are within reasonable global bounds
      if (lat < -90 || lat > 90 || lng < -180 || lng > 180) {
        return false;
      }

      // Check if coordinates are within country bounds based on selected country
      if (this.selectedCountry === 'Ghana') {
        return (
          lat >= this.ghanaBounds.south &&
          lat <= this.ghanaBounds.north &&
          lng >= this.ghanaBounds.west &&
          lng <= this.ghanaBounds.east
        );
      } else if (this.selectedCountry === 'Nigeria') {
        return (
          lat >= this.nigeriaBounds.south &&
          lat <= this.nigeriaBounds.north &&
          lng >= this.nigeriaBounds.west &&
          lng <= this.nigeriaBounds.east
        );
      }

      return true; // Default to valid if country not specified
    };

    this.isValidGpsLocation = isValidRange(this.latitude, this.longitude);

    if (!this.isValidGpsLocation) {
      this._matsnackbar.open(
        `Selected location is outside the service area for ${this.selectedCountry}. Please select a location within ${this.selectedCountry}.`,
        'OKAY',
        { duration: 6000 }
      );
    }
  }

  ngOnDestroy(): void {
    this.form.reset();
  }
}
